export default "__VITE_ASSET__20b590e1__"